import { QuizQuestionType } from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { Type } from '@warp-drive/core/types/symbols';

import { MetaQuestionEditorComponent } from '../editors/question/meta.gts';
import type { QuestionManager } from '../types/question-manager';

/**
 * Question manager for creating page breaks in quizzes.
 * This creates a meta question with the page-break CSS class pre-applied.
 * The title defaults to "New Page" to encourage users to name it meaningfully.
 */
export const PageBreakQuestionManager: QuestionManager = {
  discriminator: () => false, // Never used for existing questions - only for creating new page breaks
  type: QuizQuestionType.Meta,
  icon: 'ph:file-dotted',
  editingIcon: 'ph:file-dotted',
  editingLabel: 'Page Break',
  label: 'New Page',
  questionComponent: MetaQuestionEditorComponent,
  scoringComponent: null,
  responseComponent: null,
  reportingComponent: null,
  defaultData: {
    css: 'page-break',
    reporting: {
      [Type]: DataTypeQuiz.QuizReportingQuestion,
      groupName: '',
      questionName: '',
    },
  },
};
